













































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import {
  countryCodeList,
  CountryCode,
  getCountryByDialCode,
  DEFAULT_COUNTRY_CODE
} from './countryCodeList'

@Component({
  name: 'PhoneNumberInput'
})
export default class PhoneNumberInput extends Vue {
  @Prop({ default: '' }) private value!: string
  @Prop({ default: DEFAULT_COUNTRY_CODE }) private countryCode!: string
  @Prop({ default: '' }) private error!: string

  private phoneNumber = ''
  private isDropdownOpen = false
  private countryCodeList = countryCodeList

  private get selectedCountry(): CountryCode {
    return getCountryByDialCode(this.countryCode) || countryCodeList[0]
  }

  private get placeholder(): string {
    return '電話番号'
  }

  @Watch('value', { immediate: true })
  private onValueChange(newVal: string) {
    this.phoneNumber = newVal
  }

  private toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen
  }

  private closeDropdown() {
    this.isDropdownOpen = false
  }

  private selectCountry(country: CountryCode) {
    this.$emit('update:countryCode', country.dialCode)
    this.isDropdownOpen = false
  }

  private onInput(e: Event) {
    const target = e.target as HTMLInputElement
    // 数字のみを許可
    const digits = (target.value || '').replace(/\D+/g, '')
    this.phoneNumber = digits
    this.$emit('input', digits)
  }
}
